export const every3Hours = (callback: (...args: any) => void) => setInterval(callback, 10800000);
